import { render } from "lit-html";
import { readCookie, createCookie } from "@utils/cookie";
import { getHtmlElementByClass } from "@utils/index";
import { OnboardingTooltipTemplate } from "./template";

export default class OnboardingTooltipComponent {
  private COMMUNITY_MYSEARCHES_COOKIE_NAME = 'JROT';
  private COMMUNITY_MYSEARCHES_COOKIE_VALUE = 'cms';
  private TOOLTIP_WRAPPER_CLASS = 'onboarding-tooltip-wrapper';
  private SIDEBAR_TOOLS_CLASS = 'sidebar-tool';

  constructor(readonly messages: IMessages = window.jrConfigGlobal.messages) { }

  init = (): void => {
    const cmsCookieValue = readCookie(this.COMMUNITY_MYSEARCHES_COOKIE_NAME);

    if (!cmsCookieValue) {
      this.render();
    }
  }

  close = (): void => {
    this.removeSidebarToolsClass();
    this.removeTooltip();
  }

  private render = (): void => {
    this.addSidebarToolsClass();
    render(OnboardingTooltipTemplate({ messages: this.messages, close: this.close }), getHtmlElementByClass(this.TOOLTIP_WRAPPER_CLASS));
    createCookie(this.COMMUNITY_MYSEARCHES_COOKIE_NAME, this.COMMUNITY_MYSEARCHES_COOKIE_VALUE, { days: 365 });
  }

  private addSidebarToolsClass = (): void => {
    const sidebarContaier = getHtmlElementByClass(this.SIDEBAR_TOOLS_CLASS);
    if (sidebarContaier) {
      sidebarContaier.classList.add('highlighted');
    }
  }

  private removeSidebarToolsClass = (): void => {
    const sidebarContaier = getHtmlElementByClass(this.SIDEBAR_TOOLS_CLASS);
    if (sidebarContaier) {
      sidebarContaier.classList.remove('highlighted');
    }
  }

  private removeTooltip = (): void => {
    const tooltipWrapper = getHtmlElementByClass(this.TOOLTIP_WRAPPER_CLASS);
    if (tooltipWrapper) {
      setTimeout(() => {
        tooltipWrapper.remove();
      });
    }
  }
}